import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { loginPathWithNext, signupPathWithNext } from '../lib/gate-paths';

/**
 * 비로그인 받기 안내 모달 (LIB-U-03 AC-2 — D3 게이트 UX).
 *
 * 벽이 아니라 제안이다: 왜 로그인인지(자료함 보존)를 먼저 말하고,
 * 로그인·가입 어느 쪽으로 가든 돌아올 곳(next)을 들고 간다.
 */
export function DownloadGateModal({
  next,
  onClose,
}: {
  next: string;
  onClose: () => void;
}): ReactElement {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="download-gate-heading"
      className="fixed inset-0 z-50 grid place-items-center bg-black/40 p-4"
    >
      <div className="flex w-full max-w-[22rem] flex-col gap-4 rounded-lg border border-border bg-background p-6 shadow-lg">
        <div className="flex flex-col gap-1.5">
          <h2 id="download-gate-heading" className="text-[1.0625rem] font-bold tracking-[-0.03em]">
            로그인하고 바로 받으세요
          </h2>
          <p className="text-[13.5px] leading-[1.7] text-muted-foreground">
            자료는 전부 무료입니다. 로그인해 두시면 받은 자료가{' '}
            <b className="font-medium text-foreground">내 자료함</b>에 남아 어느 기기에서든 다시
            내려받을 수 있습니다.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <Link
            to={loginPathWithNext(next)}
            className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-[14px] font-semibold text-primary-foreground hover:bg-primary/85"
          >
            로그인하고 받기
          </Link>
          <Link
            to={signupPathWithNext(next)}
            className="inline-flex h-10 items-center justify-center rounded-md border border-foreground px-4 text-[14px] font-medium"
          >
            처음이신가요? 회원가입
          </Link>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="self-center text-[12.5px] text-muted-foreground underline underline-offset-4 hover:text-foreground"
        >
          다음에 하기
        </button>
      </div>
    </div>
  );
}
